import React, { CSSProperties } from "react";
import "./style.css";
import { icon } from "./types";
export interface IconProp {
  type: icon;
  className?: string;
  style?: CSSProperties;
}
export const Icon: React.FC<IconProp> = ({ type, className = "", style }) => {
  return <span className={`icon-${type} ${className}`} style={style}></span>;
};
